// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TeamToDo_teamTodo_search_section__w-RSB {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 35px;
}
.TeamToDo_teamTodo_search__xWtW\\+ {
  width: 400px;
  height: 45px;
  border-radius: 50px;
}
.TeamToDo_teamTodo_Add_button__0kAHY {
  width: 45px;
  height: 45px;
  border-radius: 50px;
  background-color: #007bff;
  color: white;
  font-size: 20px;
  font-weight: bold;
  font-size: 30px;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 480px) {
  .TeamToDo_teamTodo_search_section__w-RSB {
    flex-direction: column;
    align-items: center;
  }
  .TeamToDo_teamTodo_search__xWtW\\+ {
    width: 85%;
    margin-bottom: 10px;
  }
  .TeamToDo_teamTodo_Add_button__0kAHY {
    width: 150px;
  }
}

.TeamToDo_teamToDoTableContainer__gqY2A {
  width: 95%;
  margin: 10px auto;
  text-align: center;
}

.TeamToDo_teamToDoTableTitle__lOtvo {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.TeamToDo_tableWrapper__Yu7k0 {
  overflow-x: auto;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.TeamToDo_teamToDoTable__jJ1mG {
  width: 100%;
  border-collapse: collapse;
  background: white;
}

.TeamToDo_teamToDoTable__jJ1mG th,
.TeamToDo_teamToDoTable__jJ1mG td {
  padding: 12px;
  text-align: center;
  border: 1px solid #ddd;
}

.TeamToDo_teamToDoTable__jJ1mG th {
  background: #007bff;
  color: white;
  font-size: 16px;
}

.TeamToDo_teamToDoTable__jJ1mG tbody tr:nth-child(even) {
  background: #f9f9f9;
}

.TeamToDo_teamToDoTable__jJ1mG tbody tr:hover {
  background: #f1f1f1;
}

.TeamToDo_noData__xDPFs {
  text-align: center;
  font-size: 16px;
  color: #888;
  padding: 15px;
}
.TeamToDo_teamToDoTable__jJ1mG td button {
  background-color: #007bff; /* Primary Blue */
  color: #fff; /* White Text */
  border: none;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: bold;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.TeamToDo_teamToDoTable__jJ1mG td button:hover {
  background-color: #0056b3; /* Darker Blue */
}

.TeamToDo_teamToDoTable__jJ1mG td button:active {
  transform: scale(0.95);
}
/* Pagination */
.TeamToDo_pagination__lxm1\\+ {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  gap: 10px;
}

.TeamToDo_pageButton__uiKJ7 {
  background: #007bff;
  color: white;
  padding: 8px 12px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
}

.TeamToDo_pageButton__uiKJ7:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.TeamToDo_pageInfo__F2CSJ {
  font-size: 16px;
  font-weight: bold;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .TeamToDo_teamToDoTable__jJ1mG th,
  .TeamToDo_teamToDoTable__jJ1mG td {
    padding: 10px;
    font-size: 14px;
  }
}

@media (max-width: 768px) {
  .TeamToDo_teamToDoTableContainer__gqY2A {
    width: 100%;
    padding: 10px;
  }

  .TeamToDo_teamToDoTable__jJ1mG th,
  .TeamToDo_teamToDoTable__jJ1mG td {
    padding: 8px;
    font-size: 13px;
  }

  .TeamToDo_teamToDoTableTitle__lOtvo {
    font-size: 20px;
  }

  .TeamToDo_pagination__lxm1\\+ {
    flex-direction: column;
    gap: 5px;
  }
}

@media (max-width: 480px) {
  .TeamToDo_teamToDoTable__jJ1mG th,
  .TeamToDo_teamToDoTable__jJ1mG td {
    padding: 6px;
    font-size: 12px;
  }

  .TeamToDo_teamToDoTableTitle__lOtvo {
    font-size: 18px;
  }

  .TeamToDo_pageButton__uiKJ7 {
    padding: 6px 10px;
    font-size: 12px;
  }

  .TeamToDo_pageInfo__F2CSJ {
    font-size: 14px;
  }
}

.TeamToDo_teamTodo_Add_remark_overlay__CH35T {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 10px;
}

.TeamToDo_teamTodo_Add_remark_popup__46rcX {
  background: white;
  width: 90%;
  max-width: 400px;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  text-align: center;
  position: relative;
}

.TeamToDo_teamTodo_Add_remark_close__LYWq1 {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
}

.TeamToDo_teamTodo_Add_remark_title__gWB3l {
  font-size: 22px;
  margin-bottom: 15px;
  font-weight: bold;
}

.TeamToDo_teamTodo_Add_remark_content__8SeeN {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.TeamToDo_teamTodo_Add_remark_phone_section__CDNsW,
.TeamToDo_teamTodo_Add_remark_email_section__aXjTa,
.TeamToDo_teamTodo_Add_remark_whatsapp_section__TWIUY,
.TeamToDo_teamTodo_Add_remark_Physical_Meeting_section__Hy7HQ,
.TeamToDo_teamTodo_Add_remark_Net_Searching_section__t4jlY,
.TeamToDo_teamTodo_Add_remark_Meeting_section__2B2rL,
.TeamToDo_teamTodo_Add_remark_Report_section__glFzU,
.TeamToDo_teamTodo_Add_remark_Miscellaneous_section__do0Tl {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
  padding: 10px;
  border-radius: 5px;
  transition: background 0.3s;
}

.TeamToDo_teamTodo_Add_remark_phone_section__CDNsW:hover,
.TeamToDo_teamTodo_Add_remark_email_section__aXjTa:hover,
.TeamToDo_teamTodo_Add_remark_whatsapp_section__TWIUY:hover,
.TeamToDo_teamTodo_Add_remark_Physical_Meeting_section__Hy7HQ:hover,
.TeamToDo_teamTodo_Add_remark_Net_Searching_section__t4jlY:hover,
.TeamToDo_teamTodo_Add_remark_Meeting_section__2B2rL:hover,
.TeamToDo_teamTodo_Add_remark_Report_section__glFzU:hover,
.TeamToDo_teamTodo_Add_remark_Miscellaneous_section__do0Tl:hover {
  background: #e2e6ea;
}

.TeamToDo_teamTodo_Add_remark_button__af81m {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.3s;
}

.TeamToDo_teamTodo_Add_remark_button__af81m:hover {
  background-color: #0056b3;
}

/* Responsive Design */

/* Tablets */
@media (max-width: 768px) {
  .TeamToDo_teamTodo_Add_remark_popup__46rcX {
    width: 80%;
    padding: 15px;
  }

  .TeamToDo_teamTodo_Add_remark_title__gWB3l {
    font-size: 20px;
  }

  .TeamToDo_teamTodo_Add_remark_content__8SeeN {
    gap: 8px;
  }

  .TeamToDo_teamTodo_Add_remark_button__af81m {
    padding: 7px 12px;
    font-size: 13px;
  }
}

/* Mobile Devices */
@media (max-width: 480px) {
  .TeamToDo_teamTodo_Add_remark_popup__46rcX {
    width: 95%;
    padding: 15px;
  }

  .TeamToDo_teamTodo_Add_remark_title__gWB3l {
    font-size: 18px;
  }

  .TeamToDo_teamTodo_Add_remark_phone_section__CDNsW,
  .TeamToDo_teamTodo_Add_remark_email_section__aXjTa,
  .TeamToDo_teamTodo_Add_remark_whatsapp_section__TWIUY,
  .TeamToDo_teamTodo_Add_remark_Physical_Meeting_section__Hy7HQ,
  .TeamToDo_teamTodo_Add_remark_Net_Searching_section__t4jlY,
  .TeamToDo_teamTodo_Add_remark_Meeting_section__2B2rL,
  .TeamToDo_teamTodo_Add_remark_Report_section__glFzU,
  .TeamToDo_teamTodo_Add_remark_Miscellaneous_section__do0Tl {
    flex-direction: column;
    align-items: center;
    padding: 8px;
  }

  .TeamToDo_teamTodo_Add_remark_button__af81m {
    width: 100%;
    padding: 10px;
    font-size: 14px;
  }
}

/* phone */

.TeamToDo_phone_Add_remark_overlay__lpXai {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 10px;
}

.TeamToDo_phone_Add_remark_popup__dqfLd {
  background: white;
  width: 90%;
  max-width: 400px;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  text-align: center;
  position: relative;
}

.TeamToDo_phone_Add_remark_close__Klz5- {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #333;
}

.TeamToDo_phone_Add_remark_title__ZBJ8E {
  font-size: 22px;
  margin-bottom: 15px;
  font-weight: bold;
  color: #333;
}

.TeamToDo_phone_Add_remark_content__LTzhD {
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
}

.TeamToDo_phone_Add_remark_section__lfFvq {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.TeamToDo_phone_Add_remark_input__b2Kkf {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.TeamToDo_phone_Add_remark_button__Ln-5N {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s;
  width: 100%;
}

.TeamToDo_phone_Add_remark_button__Ln-5N:hover {
  background-color: #0056b3;
}

/* Responsive Design */

/* Tablets */
@media (max-width: 768px) {
  .TeamToDo_phone_Add_remark_popup__dqfLd {
    width: 80%;
    padding: 15px;
  }

  .TeamToDo_phone_Add_remark_title__ZBJ8E {
    font-size: 20px;
  }

  .TeamToDo_phone_Add_remark_input__b2Kkf {
    font-size: 14px;
    padding: 8px;
  }

  .TeamToDo_phone_Add_remark_button__Ln-5N {
    padding: 8px 12px;
    font-size: 14px;
  }
}

/* Mobile Devices */
@media (max-width: 480px) {
  .TeamToDo_phone_Add_remark_popup__dqfLd {
    width: 95%;
    padding: 15px;
  }

  .TeamToDo_phone_Add_remark_title__ZBJ8E {
    font-size: 18px;
  }

  .TeamToDo_phone_Add_remark_input__b2Kkf {
    font-size: 14px;
    padding: 8px;
  }

  .TeamToDo_phone_Add_remark_button__Ln-5N {
    padding: 10px;
    font-size: 14px;
  }
}
/* email */
.TeamToDo_email_Add_remark_overlay__vg7kt {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.TeamToDo_email_Add_remark_popup__uBkRT {
  background: white;
  padding: 20px;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  text-align: center;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  position: relative;
  animation: TeamToDo_fadeIn__1RF09 0.3s ease-in-out;
}

.TeamToDo_email_Add_remark_close__mEs5K {
  background: none;
  border: none;
  font-size: 22px;
  font-weight: bold;
  position: absolute;
  right: 15px;
  top: 10px;
  cursor: pointer;
}

.TeamToDo_email_Add_remark_title__kdIon {
  font-size: 22px;
  margin-bottom: 8px;
  color: #333;
}

.TeamToDo_email_Add_remark_counter__7Kuke {
  font-size: 16px;
  color: #666;
  margin-bottom: 15px;
}

.TeamToDo_email_Add_remark_content__5dRHA {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.TeamToDo_email_Add_remark_input__GwxKY {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 16px;
}

.TeamToDo_email_Add_remark_button__27Z3Z {
  background: #007bff;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s;
}

.TeamToDo_email_Add_remark_button__27Z3Z:hover {
  background: #0056b3;
}

@media (max-width: 768px) {
  .TeamToDo_email_Add_remark_popup__uBkRT {
    width: 95%;
    padding: 15px;
  }

  .TeamToDo_email_Add_remark_title__kdIon {
    font-size: 20px;
  }

  .TeamToDo_email_Add_remark_button__27Z3Z {
    font-size: 14px;
    padding: 8px;
  }
}

@keyframes TeamToDo_fadeIn__1RF09 {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* whatapp */
.TeamToDo_whatsapp_Add_remark_overlay__zohiD {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.TeamToDo_whatsapp_Add_remark_popup__HI43v {
  background: white;
  padding: 20px;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  text-align: center;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  position: relative;
  animation: TeamToDo_fadeIn__1RF09 0.3s ease-in-out;
}

.TeamToDo_whatsapp_Add_remark_close__waMun {
  background: none;
  border: none;
  font-size: 22px;
  font-weight: bold;
  position: absolute;
  right: 15px;
  top: 10px;
  cursor: pointer;
}

.TeamToDo_whatsapp_Add_remark_title__RJ9LM {
  font-size: 22px;
  margin-bottom: 8px;
  color: #333;
}

.TeamToDo_whatsapp_Add_remark_counter__8jX21 {
  font-size: 16px;
  color: #666;
  margin-bottom: 15px;
}

.TeamToDo_whatsapp_Add_remark_content__PbgnH {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.TeamToDo_whatsapp_Add_remark_input__N8p33 {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 16px;
}

.TeamToDo_whatsapp_Add_remark_button__3f2dY {
  background: #0056b3;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s;
}

.TeamToDo_whatsapp_Add_remark_button__3f2dY:hover {
  background: #0056b3;
}

@media (max-width: 768px) {
  .TeamToDo_whatsapp_Add_remark_popup__HI43v {
    width: 95%;
    padding: 15px;
  }

  .TeamToDo_whatsapp_Add_remark_title__RJ9LM {
    font-size: 20px;
  }

  .TeamToDo_whatsapp_Add_remark_button__3f2dY {
    font-size: 14px;
    padding: 8px;
  }
}

@keyframes TeamToDo_fadeIn__1RF09 {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* physical */
.TeamToDo_physical_Add_remark_overlay__ltCzc {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.TeamToDo_physical_Add_remark_popup__-whWW {
  background: white;
  padding: 20px;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  text-align: center;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  position: relative;
  animation: TeamToDo_fadeIn__1RF09 0.3s ease-in-out;
}

.TeamToDo_physical_Add_remark_close__Y\\+33n {
  background: none;
  border: none;
  font-size: 22px;
  font-weight: bold;
  position: absolute;
  right: 15px;
  top: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
}

.TeamToDo_physical_Add_remark_close_text__nJIXI {
  font-size: 14px;
  color: #666;
}

.TeamToDo_physical_Add_remark_title__fZ9Mu {
  font-size: 22px;
  margin-bottom: 8px;
  color: #333;
}

.TeamToDo_physical_Add_remark_counter__C3dCy {
  font-size: 16px;
  color: #666;
  margin-bottom: 15px;
}

.TeamToDo_physical_Add_remark_content__RAt8M {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.TeamToDo_physical_Add_remark_input__3NhXB {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 16px;
}

.TeamToDo_physical_Add_remark_button__Qghmh {
  background: #0056b3;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s;
}

.TeamToDo_physical_Add_remark_button__Qghmh:hover {
  background: #0056b3;
}

@media (max-width: 768px) {
  .TeamToDo_physical_Add_remark_popup__-whWW {
    width: 95%;
    padding: 15px;
  }

  .TeamToDo_physical_Add_remark_title__fZ9Mu {
    font-size: 20px;
  }

  .TeamToDo_physical_Add_remark_button__Qghmh {
    font-size: 14px;
    padding: 8px;
  }
}

@keyframes TeamToDo_fadeIn__1RF09 {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.TeamToDo_netSearching_Add_remark_overlay__k0Mlx {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.TeamToDo_netSearching_Add_remark_popup__Bir\\+y {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.TeamToDo_netSearching_Add_remark_close__P1jLD {
  margin-left: 280px;
  cursor: pointer;
  font-size: 24px;
}
.TeamToDo_netSearching_Add_remark_add_button__QDw1Z {
  background: #0056b3;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.TeamToDo_netSearching_Add_remark_popup__Bir\\+y input {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .TeamToDo_netSearching_Add_remark_popup__Bir\\+y {
    width: 95%;
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .TeamToDo_netSearching_Add_remark_popup__Bir\\+y {
    width: 90%;
    padding: 10px;
  }
}
.TeamToDo_meeting_Add_remark_overlay__SeYEM {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.TeamToDo_meeting_Add_remark_popup__k-uO\\+ {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
}
.TeamToDo_meeting_Add_remark_close__vpbnA {
  margin-left: 280px;
  cursor: pointer;
  font-size: 24px;
}
.TeamToDo_meeting_Add_remark_add_button__I1-8p {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  width: 100%;
}

.TeamToDo_meeting_Add_remark_popup__k-uO\\+ input {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .TeamToDo_meeting_Add_remark_popup__k-uO\\+ {
    width: 95%;
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .TeamToDo_meeting_Add_remark_popup__k-uO\\+ {
    width: 90%;
    padding: 10px;
  }
}
.TeamToDo_report_Add_remark_overlay__pIXNc {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.TeamToDo_report_Add_remark_popup__TjMRC {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
}
.TeamToDo_report_Add_remark_popup_close__9yjc0 {
  margin-left: 280px;
  cursor: pointer;
  font-size: 24px;
}
.TeamToDo_report_Add_remark_add_button__tTTNl {
  background-color: #1c59dd;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  width: 100%;
}

.TeamToDo_report_Add_remark_popup__TjMRC input {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .TeamToDo_report_Add_remark_popup__TjMRC {
    width: 95%;
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .TeamToDo_report_Add_remark_popup__TjMRC {
    width: 90%;
    padding: 10px;
  }
}
.TeamToDo_miscellaneous_Add_remark_overlay__t5hbi {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.TeamToDo_miscellaneous_Add_remark_popup__CXzEL {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
}
.TeamToDo_miscellaneous_Add_remark_popup_close__R9EFB {
  background: none;
  border: none;
  font-size: 22px;
  font-weight: bold;
  /* position: absolute; */
  right: 15px;
  top: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
}
.TeamToDo_miscellaneous_Add_remark_add_button__dP8Jg {
  background: #0056b3;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s;
  width: 220px;
}

.TeamToDo_miscellaneous_Add_remark_popup__CXzEL input {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .TeamToDo_miscellaneous_Add_remark_popup__CXzEL {
    width: 95%;
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .TeamToDo_miscellaneous_Add_remark_popup__CXzEL {
    width: 90%;
    padding: 10px;
  }
}

.TeamToDo_phone_popup_overlay__ABkZ2 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.TeamToDo_phone_popup_card__DjvLJ {
  background: white;
  width: 90%;
  max-width: 400px;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  position: relative;
}

.TeamToDo_phone_popup_close__w45fr {
  position: absolute;
  top: 10px;
  right: 15px;
  border: none;
  background: none;
  font-size: 18px;
  cursor: pointer;
  color: #333;
}
.TeamToDo_phone_popup_delete_button__16kOz {
  background: #f44336;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;
}
.TeamToDo_phone_popup_title__ZU03L {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 15px;
}

.TeamToDo_phone_popup_content__85dRu {
  max-height: 300px;
  overflow-y: auto;
}

.TeamToDo_phone_popup_item__Xs1b2 {
  background: #f9f9f9;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 10px;
}

.TeamToDo_phone_popup_item__Xs1b2 p {
  margin: 5px 0;
  font-size: 14px;
  color: #333;
}

.TeamToDo_phone_no_data__FGqd\\+ {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #888;
  padding: 20px;
}

@media (max-width: 768px) {
  .TeamToDo_phone_popup_card__DjvLJ {
    width: 95%;
    max-width: 350px;
  }
}

@media (max-width: 480px) {
  .TeamToDo_phone_popup_title__ZU03L {
    font-size: 18px;
  }

  .TeamToDo_phone_popup_item__Xs1b2 p {
    font-size: 13px;
  }

  .TeamToDo_phone_popup_card__DjvLJ {
    width: 90%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/TeamToDo.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,aAAa;AACf;AACA;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,WAAW,EAAE,eAAe;EAC5B,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;AAC7C;;AAEA;EACE,sBAAsB;AACxB;AACA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;;IAEE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,aAAa;EACf;;EAEA;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;AACF;;AAEA;EACE;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;;;;;;EAQE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;;;;;;;;EAQE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;;AAEtB,YAAY;AACZ;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;;;;;IAQE,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;EACjB;AACF;;AAEA,UAAU;;AAEV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;;AAEtB,YAAY;AACZ;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF;AACA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,kDAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,kDAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,aAAa;AACb;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,kDAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;AACF;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;AACF;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;AACF;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".teamTodo_search_section {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  margin-bottom: 20px;\n  margin-top: 35px;\n}\n.teamTodo_search {\n  width: 400px;\n  height: 45px;\n  border-radius: 50px;\n}\n.teamTodo_Add_button {\n  width: 45px;\n  height: 45px;\n  border-radius: 50px;\n  background-color: #007bff;\n  color: white;\n  font-size: 20px;\n  font-weight: bold;\n  font-size: 30px;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n@media (max-width: 480px) {\n  .teamTodo_search_section {\n    flex-direction: column;\n    align-items: center;\n  }\n  .teamTodo_search {\n    width: 85%;\n    margin-bottom: 10px;\n  }\n  .teamTodo_Add_button {\n    width: 150px;\n  }\n}\n\n.teamToDoTableContainer {\n  width: 95%;\n  margin: 10px auto;\n  text-align: center;\n}\n\n.teamToDoTableTitle {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 15px;\n  color: #333;\n}\n\n.tableWrapper {\n  overflow-x: auto;\n  border-radius: 8px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.teamToDoTable {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n}\n\n.teamToDoTable th,\n.teamToDoTable td {\n  padding: 12px;\n  text-align: center;\n  border: 1px solid #ddd;\n}\n\n.teamToDoTable th {\n  background: #007bff;\n  color: white;\n  font-size: 16px;\n}\n\n.teamToDoTable tbody tr:nth-child(even) {\n  background: #f9f9f9;\n}\n\n.teamToDoTable tbody tr:hover {\n  background: #f1f1f1;\n}\n\n.noData {\n  text-align: center;\n  font-size: 16px;\n  color: #888;\n  padding: 15px;\n}\n.teamToDoTable td button {\n  background-color: #007bff; /* Primary Blue */\n  color: #fff; /* White Text */\n  border: none;\n  padding: 8px 12px;\n  font-size: 14px;\n  font-weight: bold;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n}\n\n.teamToDoTable td button:hover {\n  background-color: #0056b3; /* Darker Blue */\n}\n\n.teamToDoTable td button:active {\n  transform: scale(0.95);\n}\n/* Pagination */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 15px;\n  gap: 10px;\n}\n\n.pageButton {\n  background: #007bff;\n  color: white;\n  padding: 8px 12px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.pageButton:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.pageInfo {\n  font-size: 16px;\n  font-weight: bold;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .teamToDoTable th,\n  .teamToDoTable td {\n    padding: 10px;\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 768px) {\n  .teamToDoTableContainer {\n    width: 100%;\n    padding: 10px;\n  }\n\n  .teamToDoTable th,\n  .teamToDoTable td {\n    padding: 8px;\n    font-size: 13px;\n  }\n\n  .teamToDoTableTitle {\n    font-size: 20px;\n  }\n\n  .pagination {\n    flex-direction: column;\n    gap: 5px;\n  }\n}\n\n@media (max-width: 480px) {\n  .teamToDoTable th,\n  .teamToDoTable td {\n    padding: 6px;\n    font-size: 12px;\n  }\n\n  .teamToDoTableTitle {\n    font-size: 18px;\n  }\n\n  .pageButton {\n    padding: 6px 10px;\n    font-size: 12px;\n  }\n\n  .pageInfo {\n    font-size: 14px;\n  }\n}\n\n.teamTodo_Add_remark_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 10px;\n}\n\n.teamTodo_Add_remark_popup {\n  background: white;\n  width: 90%;\n  max-width: 400px;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  position: relative;\n}\n\n.teamTodo_Add_remark_close {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n}\n\n.teamTodo_Add_remark_title {\n  font-size: 22px;\n  margin-bottom: 15px;\n  font-weight: bold;\n}\n\n.teamTodo_Add_remark_content {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.teamTodo_Add_remark_phone_section,\n.teamTodo_Add_remark_email_section,\n.teamTodo_Add_remark_whatsapp_section,\n.teamTodo_Add_remark_Physical_Meeting_section,\n.teamTodo_Add_remark_Net_Searching_section,\n.teamTodo_Add_remark_Meeting_section,\n.teamTodo_Add_remark_Report_section,\n.teamTodo_Add_remark_Miscellaneous_section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #f8f9fa;\n  padding: 10px;\n  border-radius: 5px;\n  transition: background 0.3s;\n}\n\n.teamTodo_Add_remark_phone_section:hover,\n.teamTodo_Add_remark_email_section:hover,\n.teamTodo_Add_remark_whatsapp_section:hover,\n.teamTodo_Add_remark_Physical_Meeting_section:hover,\n.teamTodo_Add_remark_Net_Searching_section:hover,\n.teamTodo_Add_remark_Meeting_section:hover,\n.teamTodo_Add_remark_Report_section:hover,\n.teamTodo_Add_remark_Miscellaneous_section:hover {\n  background: #e2e6ea;\n}\n\n.teamTodo_Add_remark_button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 8px 15px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background 0.3s;\n}\n\n.teamTodo_Add_remark_button:hover {\n  background-color: #0056b3;\n}\n\n/* Responsive Design */\n\n/* Tablets */\n@media (max-width: 768px) {\n  .teamTodo_Add_remark_popup {\n    width: 80%;\n    padding: 15px;\n  }\n\n  .teamTodo_Add_remark_title {\n    font-size: 20px;\n  }\n\n  .teamTodo_Add_remark_content {\n    gap: 8px;\n  }\n\n  .teamTodo_Add_remark_button {\n    padding: 7px 12px;\n    font-size: 13px;\n  }\n}\n\n/* Mobile Devices */\n@media (max-width: 480px) {\n  .teamTodo_Add_remark_popup {\n    width: 95%;\n    padding: 15px;\n  }\n\n  .teamTodo_Add_remark_title {\n    font-size: 18px;\n  }\n\n  .teamTodo_Add_remark_phone_section,\n  .teamTodo_Add_remark_email_section,\n  .teamTodo_Add_remark_whatsapp_section,\n  .teamTodo_Add_remark_Physical_Meeting_section,\n  .teamTodo_Add_remark_Net_Searching_section,\n  .teamTodo_Add_remark_Meeting_section,\n  .teamTodo_Add_remark_Report_section,\n  .teamTodo_Add_remark_Miscellaneous_section {\n    flex-direction: column;\n    align-items: center;\n    padding: 8px;\n  }\n\n  .teamTodo_Add_remark_button {\n    width: 100%;\n    padding: 10px;\n    font-size: 14px;\n  }\n}\n\n/* phone */\n\n.phone_Add_remark_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 10px;\n}\n\n.phone_Add_remark_popup {\n  background: white;\n  width: 90%;\n  max-width: 400px;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  position: relative;\n}\n\n.phone_Add_remark_close {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  font-weight: bold;\n  color: #333;\n}\n\n.phone_Add_remark_title {\n  font-size: 22px;\n  margin-bottom: 15px;\n  font-weight: bold;\n  color: #333;\n}\n\n.phone_Add_remark_content {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  align-items: center;\n}\n\n.phone_Add_remark_section {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.phone_Add_remark_input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.phone_Add_remark_button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 10px 15px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background 0.3s;\n  width: 100%;\n}\n\n.phone_Add_remark_button:hover {\n  background-color: #0056b3;\n}\n\n/* Responsive Design */\n\n/* Tablets */\n@media (max-width: 768px) {\n  .phone_Add_remark_popup {\n    width: 80%;\n    padding: 15px;\n  }\n\n  .phone_Add_remark_title {\n    font-size: 20px;\n  }\n\n  .phone_Add_remark_input {\n    font-size: 14px;\n    padding: 8px;\n  }\n\n  .phone_Add_remark_button {\n    padding: 8px 12px;\n    font-size: 14px;\n  }\n}\n\n/* Mobile Devices */\n@media (max-width: 480px) {\n  .phone_Add_remark_popup {\n    width: 95%;\n    padding: 15px;\n  }\n\n  .phone_Add_remark_title {\n    font-size: 18px;\n  }\n\n  .phone_Add_remark_input {\n    font-size: 14px;\n    padding: 8px;\n  }\n\n  .phone_Add_remark_button {\n    padding: 10px;\n    font-size: 14px;\n  }\n}\n/* email */\n.email_Add_remark_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.email_Add_remark_popup {\n  background: white;\n  padding: 20px;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 400px;\n  text-align: center;\n  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);\n  position: relative;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.email_Add_remark_close {\n  background: none;\n  border: none;\n  font-size: 22px;\n  font-weight: bold;\n  position: absolute;\n  right: 15px;\n  top: 10px;\n  cursor: pointer;\n}\n\n.email_Add_remark_title {\n  font-size: 22px;\n  margin-bottom: 8px;\n  color: #333;\n}\n\n.email_Add_remark_counter {\n  font-size: 16px;\n  color: #666;\n  margin-bottom: 15px;\n}\n\n.email_Add_remark_content {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.email_Add_remark_input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 16px;\n}\n\n.email_Add_remark_button {\n  background: #007bff;\n  color: white;\n  padding: 10px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background 0.3s;\n}\n\n.email_Add_remark_button:hover {\n  background: #0056b3;\n}\n\n@media (max-width: 768px) {\n  .email_Add_remark_popup {\n    width: 95%;\n    padding: 15px;\n  }\n\n  .email_Add_remark_title {\n    font-size: 20px;\n  }\n\n  .email_Add_remark_button {\n    font-size: 14px;\n    padding: 8px;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* whatapp */\n.whatsapp_Add_remark_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.whatsapp_Add_remark_popup {\n  background: white;\n  padding: 20px;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 400px;\n  text-align: center;\n  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);\n  position: relative;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.whatsapp_Add_remark_close {\n  background: none;\n  border: none;\n  font-size: 22px;\n  font-weight: bold;\n  position: absolute;\n  right: 15px;\n  top: 10px;\n  cursor: pointer;\n}\n\n.whatsapp_Add_remark_title {\n  font-size: 22px;\n  margin-bottom: 8px;\n  color: #333;\n}\n\n.whatsapp_Add_remark_counter {\n  font-size: 16px;\n  color: #666;\n  margin-bottom: 15px;\n}\n\n.whatsapp_Add_remark_content {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.whatsapp_Add_remark_input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 16px;\n}\n\n.whatsapp_Add_remark_button {\n  background: #0056b3;\n  color: white;\n  padding: 10px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background 0.3s;\n}\n\n.whatsapp_Add_remark_button:hover {\n  background: #0056b3;\n}\n\n@media (max-width: 768px) {\n  .whatsapp_Add_remark_popup {\n    width: 95%;\n    padding: 15px;\n  }\n\n  .whatsapp_Add_remark_title {\n    font-size: 20px;\n  }\n\n  .whatsapp_Add_remark_button {\n    font-size: 14px;\n    padding: 8px;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* physical */\n.physical_Add_remark_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.physical_Add_remark_popup {\n  background: white;\n  padding: 20px;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 400px;\n  text-align: center;\n  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);\n  position: relative;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.physical_Add_remark_close {\n  background: none;\n  border: none;\n  font-size: 22px;\n  font-weight: bold;\n  position: absolute;\n  right: 15px;\n  top: 10px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.physical_Add_remark_close_text {\n  font-size: 14px;\n  color: #666;\n}\n\n.physical_Add_remark_title {\n  font-size: 22px;\n  margin-bottom: 8px;\n  color: #333;\n}\n\n.physical_Add_remark_counter {\n  font-size: 16px;\n  color: #666;\n  margin-bottom: 15px;\n}\n\n.physical_Add_remark_content {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.physical_Add_remark_input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 16px;\n}\n\n.physical_Add_remark_button {\n  background: #0056b3;\n  color: white;\n  padding: 10px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background 0.3s;\n}\n\n.physical_Add_remark_button:hover {\n  background: #0056b3;\n}\n\n@media (max-width: 768px) {\n  .physical_Add_remark_popup {\n    width: 95%;\n    padding: 15px;\n  }\n\n  .physical_Add_remark_title {\n    font-size: 20px;\n  }\n\n  .physical_Add_remark_button {\n    font-size: 14px;\n    padding: 8px;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.netSearching_Add_remark_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.netSearching_Add_remark_popup {\n  background: white;\n  padding: 20px;\n  border-radius: 10px;\n  width: 90%;\n  max-width: 400px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n  text-align: center;\n}\n\n.netSearching_Add_remark_close {\n  margin-left: 280px;\n  cursor: pointer;\n  font-size: 24px;\n}\n.netSearching_Add_remark_add_button {\n  background: #0056b3;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.netSearching_Add_remark_popup input {\n  width: 100%;\n  padding: 10px;\n  margin: 10px 0;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .netSearching_Add_remark_popup {\n    width: 95%;\n    padding: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .netSearching_Add_remark_popup {\n    width: 90%;\n    padding: 10px;\n  }\n}\n.meeting_Add_remark_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.meeting_Add_remark_popup {\n  background: white;\n  padding: 20px;\n  border-radius: 10px;\n  width: 90%;\n  max-width: 400px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n  text-align: center;\n}\n.meeting_Add_remark_close {\n  margin-left: 280px;\n  cursor: pointer;\n  font-size: 24px;\n}\n.meeting_Add_remark_add_button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 10px;\n  border-radius: 5px;\n  cursor: pointer;\n  width: 100%;\n}\n\n.meeting_Add_remark_popup input {\n  width: 100%;\n  padding: 10px;\n  margin: 10px 0;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .meeting_Add_remark_popup {\n    width: 95%;\n    padding: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .meeting_Add_remark_popup {\n    width: 90%;\n    padding: 10px;\n  }\n}\n.report_Add_remark_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.report_Add_remark_popup {\n  background: white;\n  padding: 20px;\n  border-radius: 10px;\n  width: 90%;\n  max-width: 400px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n  text-align: center;\n}\n.report_Add_remark_popup_close {\n  margin-left: 280px;\n  cursor: pointer;\n  font-size: 24px;\n}\n.report_Add_remark_add_button {\n  background-color: #1c59dd;\n  color: white;\n  border: none;\n  padding: 10px;\n  border-radius: 5px;\n  cursor: pointer;\n  width: 100%;\n}\n\n.report_Add_remark_popup input {\n  width: 100%;\n  padding: 10px;\n  margin: 10px 0;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .report_Add_remark_popup {\n    width: 95%;\n    padding: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .report_Add_remark_popup {\n    width: 90%;\n    padding: 10px;\n  }\n}\n.miscellaneous_Add_remark_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.miscellaneous_Add_remark_popup {\n  background: white;\n  padding: 20px;\n  border-radius: 10px;\n  width: 90%;\n  max-width: 400px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n  text-align: center;\n}\n.miscellaneous_Add_remark_popup_close {\n  background: none;\n  border: none;\n  font-size: 22px;\n  font-weight: bold;\n  /* position: absolute; */\n  right: 15px;\n  top: 10px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.miscellaneous_Add_remark_add_button {\n  background: #0056b3;\n  color: white;\n  padding: 10px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background 0.3s;\n  width: 220px;\n}\n\n.miscellaneous_Add_remark_popup input {\n  width: 100%;\n  padding: 10px;\n  margin: 10px 0;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .miscellaneous_Add_remark_popup {\n    width: 95%;\n    padding: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .miscellaneous_Add_remark_popup {\n    width: 90%;\n    padding: 10px;\n  }\n}\n\n.phone_popup_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.phone_popup_card {\n  background: white;\n  width: 90%;\n  max-width: 400px;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);\n  position: relative;\n}\n\n.phone_popup_close {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  border: none;\n  background: none;\n  font-size: 18px;\n  cursor: pointer;\n  color: #333;\n}\n.phone_popup_delete_button {\n  background: #f44336;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-left: 10px;\n}\n.phone_popup_title {\n  text-align: center;\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 15px;\n}\n\n.phone_popup_content {\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.phone_popup_item {\n  background: #f9f9f9;\n  padding: 12px;\n  border-radius: 8px;\n  margin-bottom: 10px;\n}\n\n.phone_popup_item p {\n  margin: 5px 0;\n  font-size: 14px;\n  color: #333;\n}\n\n.phone_no_data {\n  text-align: center;\n  font-size: 16px;\n  font-weight: bold;\n  color: #888;\n  padding: 20px;\n}\n\n@media (max-width: 768px) {\n  .phone_popup_card {\n    width: 95%;\n    max-width: 350px;\n  }\n}\n\n@media (max-width: 480px) {\n  .phone_popup_title {\n    font-size: 18px;\n  }\n\n  .phone_popup_item p {\n    font-size: 13px;\n  }\n\n  .phone_popup_card {\n    width: 90%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"teamTodo_search_section": `TeamToDo_teamTodo_search_section__w-RSB`,
	"teamTodo_search": `TeamToDo_teamTodo_search__xWtW+`,
	"teamTodo_Add_button": `TeamToDo_teamTodo_Add_button__0kAHY`,
	"teamToDoTableContainer": `TeamToDo_teamToDoTableContainer__gqY2A`,
	"teamToDoTableTitle": `TeamToDo_teamToDoTableTitle__lOtvo`,
	"tableWrapper": `TeamToDo_tableWrapper__Yu7k0`,
	"teamToDoTable": `TeamToDo_teamToDoTable__jJ1mG`,
	"noData": `TeamToDo_noData__xDPFs`,
	"pagination": `TeamToDo_pagination__lxm1+`,
	"pageButton": `TeamToDo_pageButton__uiKJ7`,
	"pageInfo": `TeamToDo_pageInfo__F2CSJ`,
	"teamTodo_Add_remark_overlay": `TeamToDo_teamTodo_Add_remark_overlay__CH35T`,
	"teamTodo_Add_remark_popup": `TeamToDo_teamTodo_Add_remark_popup__46rcX`,
	"teamTodo_Add_remark_close": `TeamToDo_teamTodo_Add_remark_close__LYWq1`,
	"teamTodo_Add_remark_title": `TeamToDo_teamTodo_Add_remark_title__gWB3l`,
	"teamTodo_Add_remark_content": `TeamToDo_teamTodo_Add_remark_content__8SeeN`,
	"teamTodo_Add_remark_phone_section": `TeamToDo_teamTodo_Add_remark_phone_section__CDNsW`,
	"teamTodo_Add_remark_email_section": `TeamToDo_teamTodo_Add_remark_email_section__aXjTa`,
	"teamTodo_Add_remark_whatsapp_section": `TeamToDo_teamTodo_Add_remark_whatsapp_section__TWIUY`,
	"teamTodo_Add_remark_Physical_Meeting_section": `TeamToDo_teamTodo_Add_remark_Physical_Meeting_section__Hy7HQ`,
	"teamTodo_Add_remark_Net_Searching_section": `TeamToDo_teamTodo_Add_remark_Net_Searching_section__t4jlY`,
	"teamTodo_Add_remark_Meeting_section": `TeamToDo_teamTodo_Add_remark_Meeting_section__2B2rL`,
	"teamTodo_Add_remark_Report_section": `TeamToDo_teamTodo_Add_remark_Report_section__glFzU`,
	"teamTodo_Add_remark_Miscellaneous_section": `TeamToDo_teamTodo_Add_remark_Miscellaneous_section__do0Tl`,
	"teamTodo_Add_remark_button": `TeamToDo_teamTodo_Add_remark_button__af81m`,
	"phone_Add_remark_overlay": `TeamToDo_phone_Add_remark_overlay__lpXai`,
	"phone_Add_remark_popup": `TeamToDo_phone_Add_remark_popup__dqfLd`,
	"phone_Add_remark_close": `TeamToDo_phone_Add_remark_close__Klz5-`,
	"phone_Add_remark_title": `TeamToDo_phone_Add_remark_title__ZBJ8E`,
	"phone_Add_remark_content": `TeamToDo_phone_Add_remark_content__LTzhD`,
	"phone_Add_remark_section": `TeamToDo_phone_Add_remark_section__lfFvq`,
	"phone_Add_remark_input": `TeamToDo_phone_Add_remark_input__b2Kkf`,
	"phone_Add_remark_button": `TeamToDo_phone_Add_remark_button__Ln-5N`,
	"email_Add_remark_overlay": `TeamToDo_email_Add_remark_overlay__vg7kt`,
	"email_Add_remark_popup": `TeamToDo_email_Add_remark_popup__uBkRT`,
	"fadeIn": `TeamToDo_fadeIn__1RF09`,
	"email_Add_remark_close": `TeamToDo_email_Add_remark_close__mEs5K`,
	"email_Add_remark_title": `TeamToDo_email_Add_remark_title__kdIon`,
	"email_Add_remark_counter": `TeamToDo_email_Add_remark_counter__7Kuke`,
	"email_Add_remark_content": `TeamToDo_email_Add_remark_content__5dRHA`,
	"email_Add_remark_input": `TeamToDo_email_Add_remark_input__GwxKY`,
	"email_Add_remark_button": `TeamToDo_email_Add_remark_button__27Z3Z`,
	"whatsapp_Add_remark_overlay": `TeamToDo_whatsapp_Add_remark_overlay__zohiD`,
	"whatsapp_Add_remark_popup": `TeamToDo_whatsapp_Add_remark_popup__HI43v`,
	"whatsapp_Add_remark_close": `TeamToDo_whatsapp_Add_remark_close__waMun`,
	"whatsapp_Add_remark_title": `TeamToDo_whatsapp_Add_remark_title__RJ9LM`,
	"whatsapp_Add_remark_counter": `TeamToDo_whatsapp_Add_remark_counter__8jX21`,
	"whatsapp_Add_remark_content": `TeamToDo_whatsapp_Add_remark_content__PbgnH`,
	"whatsapp_Add_remark_input": `TeamToDo_whatsapp_Add_remark_input__N8p33`,
	"whatsapp_Add_remark_button": `TeamToDo_whatsapp_Add_remark_button__3f2dY`,
	"physical_Add_remark_overlay": `TeamToDo_physical_Add_remark_overlay__ltCzc`,
	"physical_Add_remark_popup": `TeamToDo_physical_Add_remark_popup__-whWW`,
	"physical_Add_remark_close": `TeamToDo_physical_Add_remark_close__Y+33n`,
	"physical_Add_remark_close_text": `TeamToDo_physical_Add_remark_close_text__nJIXI`,
	"physical_Add_remark_title": `TeamToDo_physical_Add_remark_title__fZ9Mu`,
	"physical_Add_remark_counter": `TeamToDo_physical_Add_remark_counter__C3dCy`,
	"physical_Add_remark_content": `TeamToDo_physical_Add_remark_content__RAt8M`,
	"physical_Add_remark_input": `TeamToDo_physical_Add_remark_input__3NhXB`,
	"physical_Add_remark_button": `TeamToDo_physical_Add_remark_button__Qghmh`,
	"netSearching_Add_remark_overlay": `TeamToDo_netSearching_Add_remark_overlay__k0Mlx`,
	"netSearching_Add_remark_popup": `TeamToDo_netSearching_Add_remark_popup__Bir+y`,
	"netSearching_Add_remark_close": `TeamToDo_netSearching_Add_remark_close__P1jLD`,
	"netSearching_Add_remark_add_button": `TeamToDo_netSearching_Add_remark_add_button__QDw1Z`,
	"meeting_Add_remark_overlay": `TeamToDo_meeting_Add_remark_overlay__SeYEM`,
	"meeting_Add_remark_popup": `TeamToDo_meeting_Add_remark_popup__k-uO+`,
	"meeting_Add_remark_close": `TeamToDo_meeting_Add_remark_close__vpbnA`,
	"meeting_Add_remark_add_button": `TeamToDo_meeting_Add_remark_add_button__I1-8p`,
	"report_Add_remark_overlay": `TeamToDo_report_Add_remark_overlay__pIXNc`,
	"report_Add_remark_popup": `TeamToDo_report_Add_remark_popup__TjMRC`,
	"report_Add_remark_popup_close": `TeamToDo_report_Add_remark_popup_close__9yjc0`,
	"report_Add_remark_add_button": `TeamToDo_report_Add_remark_add_button__tTTNl`,
	"miscellaneous_Add_remark_overlay": `TeamToDo_miscellaneous_Add_remark_overlay__t5hbi`,
	"miscellaneous_Add_remark_popup": `TeamToDo_miscellaneous_Add_remark_popup__CXzEL`,
	"miscellaneous_Add_remark_popup_close": `TeamToDo_miscellaneous_Add_remark_popup_close__R9EFB`,
	"miscellaneous_Add_remark_add_button": `TeamToDo_miscellaneous_Add_remark_add_button__dP8Jg`,
	"phone_popup_overlay": `TeamToDo_phone_popup_overlay__ABkZ2`,
	"phone_popup_card": `TeamToDo_phone_popup_card__DjvLJ`,
	"phone_popup_close": `TeamToDo_phone_popup_close__w45fr`,
	"phone_popup_delete_button": `TeamToDo_phone_popup_delete_button__16kOz`,
	"phone_popup_title": `TeamToDo_phone_popup_title__ZU03L`,
	"phone_popup_content": `TeamToDo_phone_popup_content__85dRu`,
	"phone_popup_item": `TeamToDo_phone_popup_item__Xs1b2`,
	"phone_no_data": `TeamToDo_phone_no_data__FGqd+`
};
export default ___CSS_LOADER_EXPORT___;
